import TransactionsList from './TransactionsList';

export default TransactionsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/TransactionsList/index.js